
    import { Component, Vue } from 'vue-property-decorator';
    import { mapActions, mapMutations, mapState } from 'vuex';
    import ReiseartenDetail from '@/components/Reisearten/ReiseartenDetail.vue';
    import Reiseart from '@/types/Reiseart';
    import { LoadReiseartenPayload, ReiseartenFilter } from '@/store/reisearten';
    import { DataTableHeaders } from '@/types';

    @Component({
        components: {
            ReiseartenDetail,
        },
        computed: {
            ...mapState('reisearten', ['reisearten', 'dialogs', 'loaders']),
        },
        methods: {
            ...mapActions('reisearten', ['loadReisearten', 'editReiseart', 'updateReiseart']),
            ...mapMutations('reisearten', ['setDialogsDetail']),
        },
    })
    export default class Reisearten extends Vue {
        public loadReisearten!: (payload?: LoadReiseartenPayload) => void;
        public setDialogsDetail!: (visible: boolean) => void;

        public reiseart = new Reiseart();
        public search = '';

        public filter: ReiseartenFilter = {
            gueltig: 'j',
        };

        public get headers(): DataTableHeaders<Reiseart> {
            return [
                { text: '', value: 'actions', sortable: false, width: 50 },
                { text: 'Reiseart', value: 'reiseart' },
                { text: 'Bezeichnung', value: 'bezeichnung' },
                { text: 'Gültig', value: 'gueltig' },
            ];
        }

        public mounted(): void {
            this.loadReisearten();
        }

        public onChangeFilter(): void {
            this.loadReisearten({ filter: this.filter });
        }

        public onClickEdit(reiseart: Reiseart): void {
            this.reiseart = { ...reiseart };
            this.setDialogsDetail(true);
        }

        public onClickNew(): void {
            this.reiseart = new Reiseart();
            this.setDialogsDetail(true);
        }
    }
